module.exports = __webpack_public_path__ + "img/qr2.84b5903c.png";